module.exports = __webpack_public_path__ + "img/13-2.475dcf74.jpg";